export default __webpack_public_path__ + "static/actuator-from-front-39fb01cc70f25581741cefd3bf797a78.jpeg";